import React from 'react';
import { H1 } from 'components/text';
import { FieldGroup, RadioButton } from 'components/forms';

const AccountType = () => {
  return (
    <>
      <H1>Select account type</H1>
      <FieldGroup name="account_type" label="">
        <RadioButton name="account_type" value="individual">
          Individual
        </RadioButton>
        <RadioButton name="account_type" value="entity">
          Institution/company
        </RadioButton>
      </FieldGroup>
    </>
  );
};

export default AccountType;
